import { TTypeOfCopyMenuModalWindow } from './copyMenuModalState/copyMenuModalContext';

export enum CopyMenuModalActionTypes {
	SET_IDS_RESTAURANTS_TO_COPY_MENU = 'SET_IDS_RESTAURANTS_TO_COPY_MENU',
	CHANGE_TYPE_OF_COPY_MENU_MODAL_WINDOW = 'CHANGE_TYPE_OF_COPY_MENU_MODAL_WINDOW',
	RESET_FIELDS = 'RESET_FIELDS',
}

interface ISetIDsRestaurantsToCopyMenu {
	type: CopyMenuModalActionTypes.SET_IDS_RESTAURANTS_TO_COPY_MENU;
	payload: {
		IDsSelectedRestaurantsToCopyMenu: string[];
	};
}

interface IChangeTypeOfCopyMenuModalWindow {
	type: CopyMenuModalActionTypes.CHANGE_TYPE_OF_COPY_MENU_MODAL_WINDOW;
	payload: {
		typeOfCopyMenuModalWindow: TTypeOfCopyMenuModalWindow;
	};
}

export type TCopyMenuModalAction = ISetIDsRestaurantsToCopyMenu | IChangeTypeOfCopyMenuModalWindow;
